<template>
    <div>
        <ul class="study-set-overview-list">
            <draggable :list="assignedStudySets" ghost-class="ghost">
                <li v-for="studySet in assignedStudySets" :key="studySet.id" class="study-set-overview-row-wrapper">
                <el-row type="flex" :gutter="0" class="study-set-overview">
                    <el-col :span="2" class="flex justify-center study-set-overview-row-toogle-button"><font-awesome-icon :icon="!isStudySetShowDetail(studySet.id) ? 'chevron-down' : 'chevron-up'" @click="toggleShowDetailStudySets(studySet.id)" /></el-col>
                    <el-col :span="6"
                    ><p class="study-set-name">{{ studySet.name }}</p></el-col
                    >
                    <el-col :span="6"
                    ><p>
                        <span class="label">{{ $t('study_sets.overview.category') }}:</span> <span class="value">{{ getCategoryLabel(studySet.category) }}</span>
                    </p>
                    </el-col>
                    <el-col :span="3">
                    <p>
                        <span class="label">{{ $t('study_sets.overview.phrases_count') }}:</span> <span class="value">{{ studySet.phrases_count }}</span>
                    </p>
                    </el-col>
                    <el-col :span="5">
                    <p>
                        <span class="label">{{ $t('study_sets.overview.created_by') }}:</span> <span class="value">{{ studySet.owner_name }}</span>
                    </p>
                    </el-col>
                    <el-col :span="2" class="flex justify-center">
                    <el-button @click="removeStudySet(studySet.id)" class="remove-study-set"><font-awesome-icon :icon="['fas', 'trash-alt']" style="color: #eb5757; font-size: 14px; line-height: 14px" /></el-button>
                    </el-col>
                </el-row>
                <el-collapse-transition>
                    <div v-show="isStudySetShowDetail(studySet.id)" class="phrases-wrapper">
                    <ul class="phrases-list">
                        <li v-for="item in getItemsOfStudySet(studySet)" :key="item.id">
                        <el-row type="flex" :gutter="24" width="100%">
                            <el-col :offset="1" :span="6">
                            {{ item.name }}
                            </el-col>
                            <el-col v-for="skill in item.skills" :key="skill" :offset="1" :span="3">
                              <i :class="`elsa-skill-` + skill" />
                            </el-col>
                        </el-row>
                        </li>
                    </ul>
                    </div>
                </el-collapse-transition>
                </li>
            </draggable>
            <li>
            <el-row type="flex" :gutter="24" class="study-set-overview">
                <el-col :span="24">
                <el-button @click="handleShowAddStudySet" class="btn-add-study-set"> <font-awesome-icon :icon="['fas', 'plus']" class="pr-px-8" /> {{ $t('study_sets.modals.addAssignment.add_study_set') }}</el-button>
                </el-col>
            </el-row>
            </li>
        </ul>
        <add-study-set v-if="modals.showAddStudySet" ref="studysetlist" :dialogVisible="modals.showAddStudySet" append-to-body v-on:closed="modals.showAddStudySet = false" v-on:add="handleAddSelectStudySet" :assignedStudySetIds="assignedStudySetIds" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { DefaultShareableOptions, DefaultCategoryOptions } from '@/constants/studySets'
import { getOptionsLabels } from '@/utils/elementUi'
import draggable from 'vuedraggable'
import AddStudySet from '@/components/modals/studysets/add-assignments/AddStudySet'
import { pathOr } from 'ramda'
import { STUDY_SET_SKILLS } from '@/constants/studySets'

export default {
    components: {
        draggable,
        AddStudySet
    },
  props: {
  },
  data() {
    return {
        showDetailStudySets: [],
        modals: {
            showAddStudySet: false
        },
    }
  },
  computed: {
    ...mapGetters({
      buildingAssignments: 'studysets/getBuildingAssignments',
      currentOrganizationType: 'organization/currentOrganizationType',
    }),
    assignedStudySets() {
      return pathOr([], ['buildingAssignments', 'studySets'])(this)
    },
    assignedStudySetIds() {
      return this.assignedStudySets.map((x) => x.id)
    },
  },
  methods: {
    ...mapActions({
        updateBuildingAssignments: 'studysets/updateBuildingAssignments',
    }),
    getCategoryLabel(v) {
      return getOptionsLabels(DefaultCategoryOptions, v)
    },
    isStudySetShowDetail(id) {
      return this.showDetailStudySets.includes(id)
    },
    toggleShowDetailStudySets(id) {
      if (this.showDetailStudySets.includes(id)) {
        this.showDetailStudySets = this.showDetailStudySets.filter((x) => x != id)
      } else {
        this.showDetailStudySets.push(id)
      }
    },
    getItemsOfStudySet(studySet) {
      if (!studySet || !studySet.phrases) {
        return 0
      }
      let items = [];
      if(studySet.items.length > 0) {
        studySet.items.forEach(item => {
          items.push({"name": item.name, "skills": item.skills_support})
        });
      } else {
        studySet.phrases.forEach(phrase => {
          items.push({"name": phrase, "skills": [STUDY_SET_SKILLS.SPEAKING]})
        });
      }
      return items;
    },
    removeStudySet(id) {
      this.updateBuildingAssignments({
        studySets: this.assignedStudySets.filter((x) => x.id != id)
      })
    },
    handleAddSelectStudySet(selectedStudySet) {
      const assignedStudySets = this.assignedStudySets
      for (let i = 0; i < selectedStudySet.length; i++) {
        if (assignedStudySets.every((x) => x.id != selectedStudySet[i].id)) {
          assignedStudySets.push(selectedStudySet[i])
        }
      }
      this.updateBuildingAssignments({
        studySets: assignedStudySets
      })
    },
    reset() {
        this.modals.showAddStudySet = false
        // this.$refs.studysetlist.reset()
    },
    handleShowAddStudySet() {
        this.modals.showAddStudySet = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/_colors.scss'; 
ul {
  list-style-type: none;
  padding-left: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
}
.study-set-overview-list {
  .study-set-overview-row-wrapper {
    box-shadow: inset 0px -1px 0px #e6e6e6;
    background: white;
    cursor: move;
  }

  > :last-child {
    margin-bottom: 0px;
    box-shadow: none;
  }

  .study-set-overview-row-toogle-button {
    cursor: pointer;
  }
}
.study-set-overview {
  font-size: 14px;
  height: 64px;
  align-items: center;
  .study-set-name {
    font-size: 16px;
    font-weight: 600;
  }

  p {
    margin-top: 0px;
    margin-bottom: 0px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: $black;
    text-align: initial;
    font-weight: 400;
  }

  .value {
    color: $black;
    text-transform: none;
    font-weight: 600;
  }
}
.btn-add-study-set {
  min-width: 150px;
  height: 40px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding:8px 16px;
  color:$black;
  font-family: 'SF Pro Display';
  margin-left: 12px;
}

.remove-study-set {
  width: 40px;
  height: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.phrases-wrapper {
  background: #f1f1f1;
  border-radius: 8px;
  padding: 16px 0px;
}

.phrases-list {
  overflow: auto;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
  padding: 0;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c2c2c2;
    // box-shadow: inset 0 0 8px #C2C2C2;
    border-radius: 100px;
  }

  > :last-child {
    margin-bottom: 0px;
    box-shadow: none;
  }

  .el-row {
    width: 100%;
    align-items: center;
  }
}
.phrases-list li {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  color: $black;
  margin-bottom: 16px;
  display: flex;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb !important;
}
</style>
